module.exports = {"pathContext":{"name":"StripePaymentType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"Payment was processed via Stripe Terminal (card tap)","isDeprecated":false,"name":"CARD_PRESENT"},{"deprecationReason":null,"description":"Payment was processed via Stripe Interac (Interac debit)","isDeprecated":false,"name":"INTERAC_PRESENT"},{"deprecationReason":null,"description":"Payment type could not be determined","isDeprecated":false,"name":"UNKNOWN"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-stripe-payment-type.json
// module id = 1318
// module chunks = 203152047843952